// Temporary front fake data for the "Recharges électriques" table.
// Unified shape = our existing EMSP CDR format (`PublicEmspCdrs`) + a `type`,
// mocking the future backend endpoint that merges CasaWatt (home) with our CDRs
// (station / on-site) and card charges. Replace with the real endpoint once the back is wired.

import { PublicEmspCdrs } from "../transactions/transactionsAPI";

export type ElectricChargeType = "STATION" | "HOME" | "ON_SITE";

export type ElectricCharge = PublicEmspCdrs & {
  type: ElectricChargeType;
};

export const fakeElectricCharges: ElectricCharge[] = [
  {
    type: "STATION",
    uuid: "e1000000-0000-4000-8000-000000000001",
    startAt: "2026-02-28T15:39:00.000Z",
    stopAt: "2026-02-28T17:56:00.000Z",
    totalCost: 13.91,
    totalEnergy: 54.3,
    totalTime: 137,
    totalParkingTime: 0,
    chargingTime: 137,
    authorizationStatus: "ALLOWED",
    locationCity: "Crèches-sur-Saône",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    cardUuid: "c1000000-0000-4000-8000-000000000001",
    vehicleUuid: "v1000000-0000-4000-8000-000000000001",
    driverUuid: "d1000000-0000-4000-8000-000000000001",
    currency: "EUR",
    locationName: "DRIVECO - Carrefour Market",
    locationType: "ON_STREET",
    locationCountry: "FR",
    locationPostalCode: "71680",
    locationAddress: "D906 Centre Commercial Les Bouchardes.",
    last4Digits: "9784",
  },
  {
    type: "HOME",
    uuid: "e1000000-0000-4000-8000-000000000002",
    startAt: "2026-02-28T21:05:00.000Z",
    stopAt: "2026-02-28T23:22:00.000Z",
    totalCost: 11.12,
    totalEnergy: 54.3,
    totalTime: 137,
    totalParkingTime: 0,
    chargingTime: 137,
    authorizationStatus: "ALLOWED",
    locationCity: "Crèches-sur-Saône",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    cardUuid: "",
    vehicleUuid: "v1000000-0000-4000-8000-000000000001",
    driverUuid: "d1000000-0000-4000-8000-000000000001",
    currency: "EUR",
    locationName: "Domicile",
    locationType: "OTHER",
    locationCountry: "FR",
    locationPostalCode: "71680",
    locationAddress: "",
    last4Digits: "",
  },
  {
    type: "ON_SITE",
    uuid: "e1000000-0000-4000-8000-000000000003",
    startAt: "2026-02-27T08:10:00.000Z",
    stopAt: "2026-02-27T10:27:00.000Z",
    totalCost: 13.91,
    totalEnergy: 54.3,
    totalTime: 137,
    totalParkingTime: 0,
    chargingTime: 137,
    authorizationStatus: "ALLOWED",
    locationCity: "Crèches-sur-Saône",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    cardUuid: "c1000000-0000-4000-8000-000000000001",
    vehicleUuid: "v1000000-0000-4000-8000-000000000001",
    driverUuid: "d1000000-0000-4000-8000-000000000001",
    currency: "EUR",
    locationName: "Site AMDR",
    locationType: "PARKING_LOT",
    locationCountry: "FR",
    locationPostalCode: "71680",
    locationAddress: "17 place de la petite Boucherie",
    last4Digits: "",
  },
  {
    type: "HOME",
    uuid: "e1000000-0000-4000-8000-000000000004",
    startAt: "2026-02-26T20:40:00.000Z",
    stopAt: "2026-02-26T22:10:00.000Z",
    totalCost: 8.24,
    totalEnergy: 32.1,
    totalTime: 90,
    totalParkingTime: 0,
    chargingTime: 90,
    authorizationStatus: "ALLOWED",
    locationCity: "Mâcon",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    cardUuid: "",
    vehicleUuid: "v1000000-0000-4000-8000-000000000001",
    driverUuid: "d1000000-0000-4000-8000-000000000001",
    currency: "EUR",
    locationName: "Domicile",
    locationType: "OTHER",
    locationCountry: "FR",
    locationPostalCode: "71000",
    locationAddress: "",
    last4Digits: "",
  },
  {
    type: "STATION",
    uuid: "e1000000-0000-4000-8000-000000000005",
    startAt: "2026-02-25T12:15:00.000Z",
    stopAt: "2026-02-25T13:05:00.000Z",
    totalCost: 6.4,
    totalEnergy: 22.7,
    totalTime: 50,
    totalParkingTime: 0,
    chargingTime: 50,
    authorizationStatus: "ALLOWED",
    locationCity: "Lyon",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    cardUuid: "c1000000-0000-4000-8000-000000000001",
    vehicleUuid: "v1000000-0000-4000-8000-000000000001",
    driverUuid: "d1000000-0000-4000-8000-000000000001",
    currency: "EUR",
    locationName: "TotalEnergies - Part-Dieu",
    locationType: "PARKING_GARAGE",
    locationCountry: "FR",
    locationPostalCode: "69003",
    locationAddress: "17 rue du Docteur Bouchut",
    last4Digits: "9784",
  },
  {
    type: "ON_SITE",
    uuid: "e1000000-0000-4000-8000-000000000006",
    startAt: "2026-02-24T18:30:00.000Z",
    stopAt: "2026-02-24T20:20:00.000Z",
    totalCost: 10.8,
    totalEnergy: 41.5,
    totalTime: 110,
    totalParkingTime: 0,
    chargingTime: 110,
    authorizationStatus: "ALLOWED",
    locationCity: "Crèches-sur-Saône",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    cardUuid: "c1000000-0000-4000-8000-000000000001",
    vehicleUuid: "v1000000-0000-4000-8000-000000000001",
    driverUuid: "d1000000-0000-4000-8000-000000000001",
    currency: "EUR",
    locationName: "Site AMDR",
    locationType: "PARKING_LOT",
    locationCountry: "FR",
    locationPostalCode: "71680",
    locationAddress: "17 place de la petite Boucherie",
    last4Digits: "",
  },
];
